/**
 * 표 모델(statementSheetModel·costBreakdownModel) 옵션 읽기 — 두 모델이 같은 판정을 쓴다.
 *
 * withNames·withCost 는 내보내기에서 개인정보·대외비를 빼는 장치라, 넣을지 말지가 흐릿한 값(null·0·'' 등)을 받으면 어느 쪽으로도
 * 짐작하지 않고 던진다. 빠진 값(undefined)만 기본값을 쓴다.
 *
 * vue·antd·xlsx 를 import 하지 않는다.
 */

/**
 * @param {object|null|undefined} opts 모델 옵션
 * @param {string} name 옵션 이름
 * @param {boolean} [fallback] 옵션이 없을 때(undefined) 값
 * @returns {boolean}
 * @throws {TypeError} true·false·undefined 가 아니면
 */
export function flagOption(opts, name, fallback = true) {
  const value = opts?.[name];
  if (value === undefined) return fallback;
  if (typeof value !== 'boolean') {
    throw new TypeError(`${name} 는 true·false 만 받는다(받은 값의 형: ${value === null ? 'null' : typeof value})`);
  }
  return value;
}
